export { default, getStaticProps } from 'containers/WorkPage/WorkPage';
